import React from 'react';
import { LinkButton } from '@ui/button';
import PropTypes from 'prop-types';
import { useReporter } from '../../reporter';
import { linkButtonClicked } from './events';

export const TrackedLink = ({
  onClick,
  analyticsEvent,
  href,
  children,
  headerText = '',
  ...rest
}) => {
  const reporter = useReporter();

  const handleLinkClick = event => {
    if (onClick) onClick?.(event);

    if (analyticsEvent) {
      reporter.tag(analyticsEvent);
    } else {
      reporter.tag(
        linkButtonClicked(
          href,
          typeof children === 'string' ? children : null,
          headerText,
        ),
      );
    }
  };

  return (
    <LinkButton href={href} onClick={handleLinkClick} {...rest}>
      {children}
    </LinkButton>
  );
};

TrackedLink.displayName = 'TrackedLink';

TrackedLink.propTypes = {
  ...LinkButton.propTypes,
  analyticsEvent: PropTypes.shape({
    type: PropTypes.string.isRequired,
    data: PropTypes.object,
  }),
};
